import React from "react";
import "./Footer.css";

const footerTranslations = {
  pt: {
    privacy: "Política de Privacidade",
    terms: "Termos de Uso",
    delete: "Excluir Conta",
    notice: "Este site respeita sua privacidade. Consulte nossa",
    and: "e",
  },
  en: {
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    delete: "Delete Account",
    notice: "This site respects your privacy. See our",
    and: "and",
  },
  es: {
    privacy: "Política de Privacidad",
    terms: "Términos de Uso",
    delete: "Eliminar Cuenta",
    notice: "Este sitio respeta tu privacidad. Consulta nuestra",
    and: "y",
  },
};

const lang = localStorage.getItem("kitoLang") || navigator.language.slice(0, 2);
const t = footerTranslations[lang] || footerTranslations.pt;

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <span className="site-footer-logo">KITO</span>
          <p className="site-footer-desc">
            Reinventando a leitura digital através de tecnologia, design e educação.
          </p>
        </div>

        <div>
          <h4 className="site-footer-title">Legal</h4>
          <ul className="site-footer-links">
            <li><a href="/termo-de-uso">{t.terms}</a></li>
            <li><a href="/politica-de-privacidade">{t.privacy}</a></li>
            <li><a href="/delete-account">{t.delete}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="site-footer-title">Empresa</h4>
          <p className="site-footer-meta">
            &copy; {new Date().getFullYear()} KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA
          </p>
          <p className="site-footer-meta">CNPJ: 57.276.139/0001-80</p>
        </div>
      </div>

      <div className="site-footer-bottom">
        {t.notice}{" "}
        <a href="/politica-de-privacidade">{t.privacy}</a>{" "}
        {t.and}{" "}
        <a href="/termo-de-uso">{t.terms}</a>.
      </div>
    </footer>
  );
}
